import { type RefObject, useEffect, useRef, useState } from 'react';

export function calculateGalleryTravel(
  rowWidth: number,
  viewportWidth: number,
  inset: number,
) {
  return Math.max(0, rowWidth - viewportWidth + inset * 2);
}

/** Move each complete photo strip through the viewport, including on mobile. */
export default function useGalleryTravel(
  containerRef: RefObject<HTMLDivElement | null>,
  direction: 'left' | 'right',
) {
  const rowRef = useRef<HTMLUListElement>(null);
  const [travel, setTravel] = useState(0);

  useEffect(() => {
    const row = rowRef.current;
    const container = containerRef.current;
    if (!row || !container) return;

    const measure = () => {
      const inset = Number.parseFloat(getComputedStyle(row)[direction]) || 0;
      setTravel(
        calculateGalleryTravel(row.scrollWidth, container.clientWidth, inset),
      );
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(row);
    observer.observe(container);
    return () => observer.disconnect();
  }, [containerRef, direction]);

  return { rowRef, travel };
}
